var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('CocoComponent',[_c('coco-banner',{attrs:{"obj":{
      src: require('./assets/banner.jpg'),
      link: 'https://coco.com',
    }}}),_c('coco-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }